import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class PromotionEndpoints {
  constructor(private http: HttpClient) {}
}
